import type { Translations } from './zh';

/**
 * 藏文 (Tibetan, ISO 639-1 = `bo`) — 现代标准藏文 (拉萨/卫藏方言书面体)。
 * 与 zh.ts 保持完全相同的键结构 (i18n-keys-completeness.spec.ts 会校验)。
 *
 * 注:本翻译为首版,建议藏文母语者校对。专有名词 "AI" / "W 云" 保留拉丁/中文原形,
 * 不做藏文音译,与项目其他 locale 保持品牌一致。
 */
export const bo: Translations = {
  bubble: {
    open: 'ཞབས་ཞུ་པ་ཁ་ཕྱེ།',
    close: 'ཞབས་ཞུ་པ་ཁ་རྒྱག',
    badge: 'གློག་ལམ་ནང་།',
    dragHint: 'གནོན་འཛིན་གྱིས་སྤོ་འགུལ་བྱེད་ཐུབ།',
  },
  panel: {
    closeAria: 'ཞབས་ཞུ་པའི་པར་སྒོ་ཁ་རྒྱག',
    languageAria: 'སྐད་ཡིག་འདེམས་པ།',
    welcomeFallback: 'བཀྲ་ཤིས་བདེ་ལེགས། ག་རེ་རོགས་རམ་དགོས།',
    quickQuestionsTitle: 'གཤམ་གྱི་དྲི་བ་འདི་དག་འདྲི་ཐུབ།',
    quickAskTitle: 'མྱུར་འདྲི།',
    inputPlaceholder: 'ཁྱེད་ཀྱི་དྲི་བ་འདིར་འབྲི་རོགས།...',
    sendButton: 'གཏོང་།',
    sendAria: 'ཕྲིན་ཡིག་གཏོང་།',
    onlineStatus: 'གློག་ལམ་ནང་།',
    thinkingAria: 'བསམ་བློ་གཏོང་བཞིན་པ།',
    aiBusyHint: 'ལན་ཡི་གེ་འདེད་བཞིན་ཡོད་པས་ཏོག་ཙམ་སྒུག་རོགས…',
    leadReopenHint: 'དགོས་ཚེ། འདིར་འབྲེལ་ལན་གནས་ཚུལ་འཇོག་རོགས།',
    startChat: 'འཕྲལ་དུ་བློ་འདྲི།',
    welcomeQuickHint: 'མྱུར་དུ་ཤེས་རྟོགས།',
    videoPreparing: 'བརྙན་འཕྲིན་གྲ་སྒྲིག་བྱེད་བཞིན་པ…',
    newMessageTitle: '💬 ཕྲིན་ཡིག་གསར་པ།',
    newMessageBody: 'ཁྱེད་ལ་ཕྲིན་ཡིག་གསར་པ་ཡོད། མནན་ནས་གཟིགས་རོགས།',
  },
  roles: {
    visitor: 'བལྟ་ཞུགས་པ།',
    ai: 'AI ལས་རོགས།',
    human: 'མི་ཡི་ཞབས་ཞུ་པ།',
    system: 'མ་ལག',
  },
  web: {
    aiChat: 'AI ཞབས་ཞུ།',
    humanChat: 'མི་ཡི་ཞབས་ཞུ།',
    switchToHuman: 'མི་ཞབས་ལ་སྤོ་བ།',
    switchToAI: 'AI ལ་ཕྱིར་ལོག',
    resetChat: 'ཡང་བསྐྱར་འགོ་འཛུགས།',
    commonQuestions: 'རྒྱུན་འབྱུང་དྲི་བ།',
    faqTitle: 'རྒྱུན་འབྱུང་དྲི་ལན།',
    selectLanguage: 'སྐད་ཡིག་འདེམས་པ།',
    maximize: 'ཆེས་ཆེར་བཟོ་བ།',
    restore: 'ཕྱིར་སློག',
    offlineLabel: 'གློག་ལམ་མེད།',
    aiGreeting:
      'བཀྲ་ཤིས་བདེ་ལེགས། ངོས་ནི་ AI ཞབས་ཞུ་པ་ཡིན། ཁྱེད་ལ་ཕན་ཐོགས་ཡོང་བར་སྨོན། ག་རེ་འདྲི་འདོད་ཡོད་པ།',
    humanGreeting: 'བཀྲ་ཤིས་བདེ་ལེགས། ཁྱེད་རང་མི་ཡི་ཞབས་ཞུ་པ་དང་འབྲེལ་མཐུད་ཟིན། ག་རེ་རོགས་རམ་བྱེད་དགོས་སམ།',
    agentOffline: 'ཞབས་ཞུ་པ་གློག་ལམ་ནང་མི་འདུག',
    agentOfflineMessage:
      'དགོངས་དག ད་ལྟ་མི་ཡི་ཞབས་ཞུ་པ་གློག་ལམ་ནང་མི་འདུག ཁྱེད་ཀྱིས་གཤམ་གྱི་ཝེ་ཁྲིན་ (WeChat) གཉིས་ཐ་འཕྲུལ་ཆས་བཤར་ནས་ངེད་ཚོར་གསར་སྦྱར་གནང་ན། ངེད་ཚོས་མགྱོགས་པར་ལན་འདེབས་བྱེད་འགྱུར།',
    wechatPrompt: 'གཉིས་ཐ་འཕྲུལ་ཆས་བཤར་ནས་ཝེ་ཁྲིན་ཞབས་ཞུ་པ་གསར་སྦྱར།',
    wechatHint: 'ཝེ་ཁྲིན་གྱི་གཉིས་ཐ་འཕྲུལ་ཆས་བཤར་སྤྱོད་ནས་ཞབས་ཞུ་པ་གསར་སྦྱར་གནང་།',
    serviceHoursLabel: 'ཞབས་ཞུ་པའི་དུས་ཚོད་ ',
    viewImage: 'པར་རིས་ལ་བལྟ།',
    playVideo: 'བརྙན་འཕྲིན་གཏོང་།',
    closeViewer: 'ཁ་རྒྱག',
    downloadFile: 'ཕབ་ལེན།',
    fileTypePdf: 'PDF ཡིག་ཆ།',
    fileTypeWord: 'Word ཡིག་ཆ།',
    fileTypeExcel: 'Excel རེའུ་མིག',
    fileTypePpt: 'PowerPoint འགྲེམས་སྟོན།',
    fileTypeArchive: 'བསྡུས་ཡིག་ཆ།',
    fileTypeGeneric: 'ཡིག་ཆ།',
  },
  leadCard: {
    ariaForm: 'འབྲེལ་བའི་རེའུ་མིག',
    title: 'ཁྱེད་ཀྱི་འབྲེལ་ལམ་འཇོག་རོགས',
    nameLabel: 'མིང་',
    namePlaceholder: 'ཁྱེད་ཀྱི་མིང་འཇུག་རོགས',
    phoneLabel: 'ཁ་པར་ཨང་གྲངས',
    phonePlaceholder: 'ཁྱེད་ཀྱི་ཁ་པར་ཨང་གྲངས་འཇུག་རོགས',
    phoneError: 'ཁ་པར་ཨང་གྲངས་ཡང་དག་པ་ཞིག་འཇུག་རོགས',
    submit: 'བསྐུར་བ',
    submitting: 'བསྐུར་བཞིན་པ…',
    dismiss: 'ཕྱིས་ལ',
    success: 'ཐོབ་ཐང་བྱུང་། ཆེད་ལས་མི་སྣ་ཁྱེད་དང་མྱུར་དུ་འབྲེལ་བ་བྱེད་ངེས།',
  },
};
